import { Button } from "@/components/ui/button";

interface HelpButtonProps {
  onClick: () => void;
}

export function HelpButton({ onClick }: HelpButtonProps) {
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={onClick}
      className="h-10 w-10"
      aria-label="Help"
      title="View help and usage guide"
    >
      <span className="text-lg font-bold">?</span>
    </Button>
  );
}
